import { render, staticRenderFns } from "./room-summary.vue?vue&type=template&id=6dfff688&scoped=true&"
import script from "./room-summary.vue?vue&type=script&lang=js&"
export * from "./room-summary.vue?vue&type=script&lang=js&"
import style0 from "./room-summary.vue?vue&type=style&index=0&id=6dfff688&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfff688",
  null
  
)

export default component.exports